import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const FirefoxIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            className="icon-firefox"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            strokeWidth="1.5"
            color="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M6.103 5.977c.01.004.005.004 0 0zm16.472 2.128c-.497-1.196-1.5-2.485-2.292-2.893.642 1.261 1.017 2.522 1.158 3.47 0 .004 0 .009.004.018-1.293-3.225-3.487-4.523-5.278-7.355-.703-1.106-.51-1.18-.614-1.153l-.005.005c-2.189 1.214-3.53 3.67-3.871 5.751a6.012 6.012 0 00-2.246.568.284.284 0 00-.145.14.306.306 0 00-.028.202c.01.042.028.08.051.108a.288.288 0 00.207.117.5.5 0 00.117-.014l.023-.01a5.603 5.603 0 012.32-.534c2.949-.023 4.557 2.067 5.049 2.92-.61-.426-1.706-.853-2.76-.67 4.115 2.058 3.008 9.122-2.687 8.869-2.789-.122-4.551-2.386-4.715-4.256 0 0 .53-1.965 3.778-1.965.351 0 1.359-.98 1.378-1.265-.005-.094-1.997-.886-2.77-1.65-.418-.408-.615-.605-.788-.75a3.498 3.498 0 00-.295-.225 5.282 5.282 0 01-.033-2.794C6.96 5.273 6.047 6.117 5.38 6.862h-.004c-.455-.571-.422-2.465-.394-2.864-.01-.023-.342.174-.385.207a7.752 7.752 0 00-1.115.956C2.719 5.939 1.41 7.509.88 9.905c-.215.956-.319 2.08-.319 2.451 0 6.314 5.12 11.433 11.433 11.433 5.658 0 10.453-4.087 11.274-9.497.539-3.595-.694-6.145-.694-6.187z"
            ></path>
        </svg>
    </IconWrapper>
)
